import React, { useEffect, useState } from "react";
import { Modal, Table, Typography, Input, Space } from "antd";
import rejectedPromoterService from "../../services/RejectedPromoterService";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;
const { Search } = Input;
const highlight = (text = "", search = "") => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, i) =>
        part.toLowerCase() === search.toLowerCase() ? (
            <Text mark key={i}>{part}</Text>
        ) : (
            <span key={i}>{part}</span>
        )
    );
};

const RejectedPromotersModal = ({ visible, onClose }) => {
    const [data, setData] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const auth = useSelector((state) => state.auth || {});

    useEffect(() => {
        if (visible) {
            setLoading(true);
            rejectedPromoterService
                .getAllWithPagination(
                    { createdBy: { value: auth.user?.username, operator: "eq" } },
                    1,
                    1000
                )
                .then((response) => {
                    setData(response.data);
                    setFiltered(response.data);
                })
                .catch(console.error)
                .finally(() => setLoading(false));
        }
    }, [auth.user?.username, visible]);

    const handleSearch = (value) => {
        setSearchText(value);
        if (!value) {
            setFiltered(data);
            return;
        }
        const lower = value.toLowerCase();
        const result = data.filter((item) =>
            Object.values(item).some(
                (val) => val && val.toString().toLowerCase().includes(lower)
            )
        );
        setFiltered(result);
    };

    const columns = [
        {
            title: "Clave de elector",
            dataIndex: "electorKey",
            key: "electorKey",
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Nombre",
            dataIndex: "name",
            key: "name",
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Apellido paterno",
            dataIndex: "firstLastName",
            key: "firstLastName",
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Apellido materno",
            dataIndex: "secondLastName",
            key: "secondLastName",
            render: (text) => highlight(text || '', searchText),
        },
        {
            title: "Teléfono",
            dataIndex: "phone",
            key: "phone",
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text) => highlight(text, searchText),
        },
        {
            title: "CP",
            dataIndex: "zipCode",
            key: "zipCode",
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Razón",
            dataIndex: "reason",
            key: "reason",
            render: (text) => <Text strong>{highlight(text, searchText)}</Text>,
        },
        {
            title: "Mensaje",
            dataIndex: "message",
            key: "message",
            render: (text) => <Text type="secondary">{highlight(text, searchText)}</Text>,
        },
    ];

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width="90%"
        >
            <Title level={2} style={{textAlign: "center", marginBottom: "20px"}}>Promotores rechazados</Title>

            <Space style={{display: "flex", justifyContent: "flex-end", marginBottom: "16px"}} direction="vertical" size="middle">
                <Search
                    placeholder="Buscar en todos los campos"
                    allowClear
                    enterButton
                    onSearch={handleSearch}
                    onChange={(e) => handleSearch(e.target.value)}
                />
            </Space>

            <Table
                rowKey="id"
                dataSource={filtered}
                columns={columns}
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: "max-content" }}
            />
        </Modal>
    );
};

export default RejectedPromotersModal;
